<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      persistent
      width="750px"
  >
    <v-card>
      <v-container>
        <v-row>
          <v-col cols="4">
            <v-btn large style="height:56px" @click="onClickCurrentLocation()">ที่นี่</v-btn>
            <v-btn large style="height:56px;margin-left: 10px" @click="onClickAddressLocation()">ค้นตามที่อยู่</v-btn>
          </v-col>
          <v-col>
            <v-text-field
                v-model="keyword"
                :append-icon="loading ? 'mdi-loading':'mdi-magnify'"
                :loading="loading"
                clearable
                hide-details
                hint="ชื่อ ตำบล อำเภอ จังหวัด"
                label="Search"
                outlined
                @click:append="onClickSearch()"
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <v-icon large
                    style="margin-top: 12px"
                    @click.stop="onClickMapIcon()"
            >mdi-map
            </v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div id="location-picker"></div>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        {{ message }}
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="onClickCancel()"
        >
          Cancel
        </v-btn>
        <v-btn

            color="primary"

            @click="onClickMap();"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>

#location-picker {
  width: 100%;
  height: 400px;
}
</style>

<script lang="ts">
import Helper from '@/services/Helper'
import LocationPicker from 'location-picker'
import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class LocationMapPicker extends Vue {

  open = true
  locationPicker: any = null

  @Prop() option: { lat: 0, lng: 0, keyword: '' }
  address: string = ''
  keyword: string = ''
  message: string = ''

  loading = false

  onClickMap() {
    console.log(this.locationPicker.getMarkerPosition())
    this.$root.$emit('applyLocationPicker', this.locationPicker.getMarkerPosition())
  }

  onClickCancel() {
    this.$root.$emit('closeLocationPicker')

  }

  async onClickAddressLocation() {
    this.keyword = this.address
    await this.onClickSearch()
  }

  async onClickCurrentLocation() {
    this.message = ''
    this.locationPicker.setCurrentPosition()
  }

  async onClickSearch() {
    this.loading = true
    this.message = 'กำลังค้น...'
    Helper.get(Helper.setting.location.locate.replace('{keyword}', encodeURIComponent(this.keyword)))
        .then<{ data: any }>(({data}) => {
          this.loading = false
          console.log('locate', data)
          if (data.success) {
            this.message = 'พบ: ' + data.geo.name
            this.locationPicker.setLocation(data.geo.lat, data.geo.lng)
          } else {
            this.message = 'ไม่พบ'
          }
        }).catch(() => this.loading = false)
    // Route::get('/location/locate/{keyword}', 'CustomerController@locate');
  }


  mounted() {
    let setCurrentPosition = false

    this.keyword = this.option.keyword
    this.address = this.option.keyword

    let mapOption: any = {
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoom: 15,
    }

    if (this.locationPicker == null) {
      if (this.option.lat == 0 || this.option.lat == undefined) {
        this.locationPicker = new LocationPicker('location-picker', {
          setCurrentPosition: true, // You can omit this, defaults to true
        }, mapOption)
      } else {
        this.locationPicker = new LocationPicker('location-picker', {
          lat: this.option.lat,
          lng: this.option.lng,
        }, mapOption)
      }

    }

  }

  onClickMapIcon() {
    let {lat, lng} = this.locationPicker.getMarkerPosition()
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank')
  }

  created() {

  }

};

</script>
